import http from '@utils/http';
const ehrToken =
  process.env.VUE_APP_RUN_ENV === 'dev'
    ? '4129b55ff6dc44bd822b78737ce3ea785a80ec7e384f470db6145aea5af7e2f4a2b32b0ccc6d4077babab5728be15e28,1326313014,dingding'
    : window.sessionStorage.getItem('dingdingAuth');

export function getDataInfo(params) {
  return http.get('/api/pact/h5/absence/queryAbsence', {
    headers: {
      ehrToken,
    },
    params,
  });
}

export function submitWarningInfo(params) {
  return http.get('/api/pact/h5/absence/saveAbsence', {
    headers: {
      ehrToken,
    },
    params,
  });
}
